'use client';

import { type ImportOptions } from '@cachemap/core';
import { GraphqlBoxUpdateProvider } from '@graphql-box/react';
import { styled } from '@mui/material';
import { type ReactNode } from 'react';
import { StoreUpdateProvider } from '#store/StoreUpdateProvider.tsx';
import { type State } from '#store/types.ts';

export type PageScaffoldProps = {
  children: ReactNode | ReactNode[];
  graphqlBoxImports: ImportOptions[];
  storeInitialState: Partial<State>;
};

const Container = styled('div')({
  minHeight: '100vh',
});

export const PageScaffold = ({ children, graphqlBoxImports, storeInitialState }: PageScaffoldProps) => {
  return (
    <Container>
      <StoreUpdateProvider initialState={storeInitialState}>
        <GraphqlBoxUpdateProvider imports={graphqlBoxImports}>{children}</GraphqlBoxUpdateProvider>
      </StoreUpdateProvider>
    </Container>
  );
};
